module.exports = __webpack_public_path__ + "static/media/searchicon.ef61f27c.svg";